module.exports = __webpack_public_path__ + "img/9_39.9831305e.png";